import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getPeerBenchmarksTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="peer-benchmarks-header"]',
    popover: {
      title: t("tour.peerBenchmarks.header.title"),
      description: t("tour.peerBenchmarks.header.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="peer-benchmarks-header"]',
    popover: {
      title: t("tour.peerBenchmarks.cropTabs.title"),
      description: t("tour.peerBenchmarks.cropTabs.description"),
      side: "bottom",
      align: "center",
    },
  },
  {
    element: '[data-tour="peer-benchmarks-overview"]',
    popover: {
      title: t("tour.peerBenchmarks.overview.title"),
      description: t("tour.peerBenchmarks.overview.description"),
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="peer-benchmarks-table"]',
    popover: {
      title: t("tour.peerBenchmarks.table.title"),
      description: t("tour.peerBenchmarks.table.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const peerBenchmarksTourConfig = {
  id: "peerBenchmarks" as const,
  steps: getPeerBenchmarksTourSteps,
};
